import { Chip } from 'Components/Chip/Chip'

import {
  bloodOrange,
  bloodOrangeFaded,
  bronzeYellow,
  bronzeYellowFaded,
  Colors,
  elfGreen,
  elfGreenFaded,
  red,
  white
} from 'Utils/styles/colors'
import { InvoiceState } from 'Utils/types/invoice'
import { displayDate } from 'Utils/helpers/dateUtils'
import { FlexRow, spacingXS } from 'Utils/styles/spacing'

type InvoiceStatusProps = {
  invoiceState: InvoiceState
  previousPaymentFailed?: boolean
  payDate?: Date
}

export const InvoiceStateLabels = {
  [InvoiceState.Processing]: 'Pending',
  [InvoiceState.Completed]: 'Paid',
  [InvoiceState.Open]: 'Due',
  [InvoiceState.Draft]: 'Draft',
  [InvoiceState.Preparing]: 'Preparing'
}

const ChipStyles: Record<InvoiceState, { text: string; backgroundColor: Colors; color: Colors }> = {
  [InvoiceState.Processing]: {
    text: InvoiceStateLabels[InvoiceState.Processing],
    backgroundColor: bronzeYellowFaded,
    color: bronzeYellow
  },
  [InvoiceState.Completed]: {
    text: InvoiceStateLabels[InvoiceState.Completed],
    backgroundColor: elfGreenFaded,
    color: elfGreen
  },
  [InvoiceState.Open]: {
    text: InvoiceStateLabels[InvoiceState.Open],
    backgroundColor: bloodOrangeFaded,
    color: bloodOrange
  },
  [InvoiceState.Draft]: {
    text: InvoiceStateLabels[InvoiceState.Draft],
    backgroundColor: bloodOrangeFaded,
    color: bloodOrange
  },
  [InvoiceState.Preparing]: {
    text: InvoiceStateLabels[InvoiceState.Preparing],
    backgroundColor: bloodOrangeFaded,
    color: bloodOrange
  }
}

export const InvoiceStatus = ({
  invoiceState,
  payDate,
  previousPaymentFailed = false
}: InvoiceStatusProps) => {
  const { backgroundColor, color, text } = ChipStyles[invoiceState]

  const chipText =
    invoiceState === InvoiceState.Completed && payDate ? `${text} on ${displayDate(payDate)}` : text

  return (
    <FlexRow gap={spacingXS}>
      <Chip backgroundColor={backgroundColor} fontColor={color} text={chipText} />
      {previousPaymentFailed && <Chip backgroundColor={red} fontColor={white} text="Failed" />}
    </FlexRow>
  )
}
